import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import acc from 'accounting'

export default class ZPrzesiadkaTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderERezerwacja(cell,row){
        if(Boolean(cell)){
            return <span style={{color:'forestgreen'}}><i className={'fa fa-check'}></i> dostępna</span>
        } else return <span style={{color:'firebrick'}}><i className={'fa fa-times'}></i> brak</span>
    }

    renderEBilet(cell,row){
        if(Boolean(cell)){
            return <span style={{color:'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
        } else return <span style={{color:'firebrick'}}><i className={'fa fa-times'}></i> brak</span>
    }

    render() {

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                hover
                                options={{noDataText: 'Brak pasujących rekordów'}}
                >
                    <TableHeaderColumn dataField='idKu' isKey dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={(cell,row)=>{return <div>{row.idKu+'/'+row.idKuPrze}</div>}}
                    >Nr kursów</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazTr' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                    >Trasa I</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazTrPrze' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                    >Trasa II</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMiOd'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-sign-in'}></i> Miejsc. od</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMiPrze'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-square-o'}></i> Przesiadka w</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMiDo'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-sign-out'}></i> Miejsc. do</TableHeaderColumn>
                    <TableHeaderColumn dataField='godz'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-sign-in'}></i> Odjazd</TableHeaderColumn>
                    <TableHeaderColumn dataField='godzPrze'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-square-o'}></i> Przesiadka o</TableHeaderColumn>
                    <TableHeaderColumn dataField='godzPrzy'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    ><i className={'fa fa-sign-out'}></i> Przyjazd</TableHeaderColumn>
                    <TableHeaderColumn dataField='ileMin'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                    >Czas trwania</TableHeaderColumn>
                    <TableHeaderColumn dataField='cena' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={(cell,row)=>{return acc.formatMoney(cell)}}
                    >Cena</TableHeaderColumn>
                   {/* <TableHeaderColumn dataField='czyERezerwacja' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderERezerwacja}
                    >e-rezerwacja?</TableHeaderColumn>
                    <TableHeaderColumn dataField='czyEBilet' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderEBilet}
                    >e-bilet?</TableHeaderColumn>*/}
                </BootstrapTable>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/szukaj/components/ZPrzesiadkaTable.js